import _ from 'lodash';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { getColor } from 'common/constants/_colors';
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import {
  SHORT_NUMERAL_DATE_FORMAT,
  DATE_FORMAT,
  MONTH_AND_YEAR_FORMAT
} from 'common/constants/constants';
import { PROJECTS } from '../services/projects.services';

const ExtendedIterationsHeader = ({
  iterations = [],
  tableHeadersWidth,
  tableHeaderWidth
}) => {
  const maxIterationsInTableHeader = '7';
  const firstIteration = _.minBy(iterations.map(({ start }) => start));
  const isShowIterations = iterations.length <= maxIterationsInTableHeader;

  return (
    <>
      <Flex grow='1' justify='flex-end'>
        {!isShowIterations && (
          <Text color='shuttleGray'>
            {moment(firstIteration).format(MONTH_AND_YEAR_FORMAT)}
          </Text>
        )}
      </Flex>
      <Flex width={tableHeadersWidth} pl='normal'>
        {iterations.map(({ name, start, end }, idx) => {
          const iterationData = (isHeaderView = false) => {
            const ellipsis = isHeaderView && {
              width: '100%',
              ellipsisAfter: tableHeaderWidth
            };

            const dateFormat = isHeaderView
              ? SHORT_NUMERAL_DATE_FORMAT
              : DATE_FORMAT;

            return (
              <Flex direction='column'>
                <Text weight='500' align='center' {...ellipsis}>
                  {name}
                </Text>
                <Text
                  pt='0.2rem'
                  size='x-small'
                  color={PROJECTS.SECONDARY_COLOR}
                  align='center'
                  {...ellipsis}
                >
                  {moment(start).format(dateFormat)} -
                  {moment(end).format(dateFormat)}
                </Text>
              </Flex>
            );
          };

          return (
            <Tooltip key={idx} interactive title={iterationData()}>
              <Flex
                direction='column'
                items='center'
                justify='center'
                grow='1'
                width={tableHeaderWidth}
              >
                {isShowIterations ? (
                  iterationData(true)
                ) : (
                  <Separator height='0.8rem' color={getColor('silverSand')} />
                )}
              </Flex>
            </Tooltip>
          );
        })}
      </Flex>
    </>
  );
};

export default ExtendedIterationsHeader;
